import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


export function getViewControlManageAccounts(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-accounts`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewControlAccountShforms(successCallback, errorCallback, accountId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/account-shforms/${accountId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewControlManageAccountCreditRecords(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-account-credit-records`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewControlAccountCreditsShforms(successCallback, errorCallback, accountId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/account-credits-shforms/${accountId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlAddAccountCredits(successCallback, errorCallback, data, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/add-credits`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postControlAddShopifyApplicationCredits(successCallback, errorCallback, data, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/add-shopify-application-credits`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export function postControlUpdateTrialDaysLeft(successCallback, errorCallback, data, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/update-trial-days-left`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewControlAddShopifyCreditsModal(successCallback, errorCallback, accountId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/add-shopify-credits-modal/${accountId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlCancelAccountServices(successCallback, errorCallback, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/cancel-services`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlAccountEnableSending(successCallback, errorCallback, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/enable-sending`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlAccountDisableSending(successCallback, errorCallback, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/disable-sending`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlConvertShopifyBillingAccount(successCallback, errorCallback, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/convert-shopify-billing`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlConvertOnVoardBillingAccount(successCallback, errorCallback, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/convert-onvoard-billing`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlFetchRecords(successCallback, errorCallback, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/fetch-records`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlFetchAllRecords(successCallback, errorCallback, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/fetch-all-records`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlFetchRecentRecords(successCallback, errorCallback, data, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/fetch-recent-records`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postControlResyncWebhooks(successCallback, errorCallback, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/resync-webhooks`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function postControlUpdateRecommenderModels(successCallback, errorCallback, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/update-recommender-models`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postControlUpdateUsage(successCallback, errorCallback, data, accountId) {
  postAuth({
    "path": `control/accounts/${accountId}/update-usage`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}
